import PoliciesPageFilter from "./PoliciesPageFilter/PoliciesPageFilter";
import PoliciesPageHeader from "./PoliciesPageHeader/PoliciesPageHeader";
import PoliciesPageList from "./PoliciesPageList/PoliciesPageList";
import { Box } from "@saviynt/design-system";
import { PoliciesFilterProvider } from "../context/PoliciesFilterContext";
import { SaveView } from "./SaveView";

/**
 * Posture Policy page component.
 *
 * Features:
 * - Page header with title and actions (PoliciesPageHeader)
 * - Search and filter controls (PoliciesPageFilter)
 * - Policies table with row selection (PoliciesPageList)
 *
 * @returns The posture policy page content
 */
export default function PoliciesPage() {
  return (
    <PoliciesFilterProvider>
      <div className="Policies-Page-Container w-full">
        <PoliciesPageHeader />

        <div className="space-y-4">
          <Box className="flex items-start px-6">
            <PoliciesPageFilter />
            <SaveView />
          </Box>
          <div className="px-6">
            <PoliciesPageList />
          </div>
        </div>
      </div>
    </PoliciesFilterProvider>
  );
}
